export const brand = {
  name: 'Templo de Ayuda Esotérica',
  phone: '+1 954-674-1691',
  phoneHref: 'tel:+19546741691',
  whatsapp: '+1 954-658-7182',
  email: 'hechizosamarresa@gmail.com',
  emailHref: 'mailto:hechizosamarresa@gmail.com',
  location: 'Miami, Florida, USA',
}

export const videoCallHref =
  'https://wa.me/19546587182?text=Hola%2C%20me%20gustar%C3%ADa%20agendar%20una%20consulta%20por%20videollamada.'

export function whatsappHref(context?: string): string {
  const base = 'Hola, me gustaría recibir orientación e información sobre sus servicios'
  const message = context ? `${base}: ${context}.` : `${base}.`
  return `https://wa.me/19546587182?text=${encodeURIComponent(message)}`
}

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/295dbc2b-2358-4fba-8d38-fe90bc0e8dc2.jpg',
  about: 'https://cdn.magicpatterns.com/patterns/generated-images/08791137-0e53-49f7-acb3-41a882383906.jpg',
  texture: 'https://cdn.magicpatterns.com/patterns/generated-images/6a0fb4ca-b49e-40ff-bbc1-61492c0c6a3a.jpg',
  altar: 'https://cdn.magicpatterns.com/patterns/generated-images/c4660cd6-6cbd-4a67-8705-8de85161cc83.jpg',
  heartsHead:
    'https://cdn.magicpatterns.com/patterns/generated-images/6c3e0db4-d0db-4714-a575-3ecd3cd18884.jpg',
  heroBackdrop:
    'https://cdn.magicpatterns.com/patterns/generated-images/9c49d66c-a8fd-4f68-b921-cc548d2d6d97.jpg',
}
